// 绘制圆环（可变半径和中心点）
export function ringCanvas(
  canvas,
  color,
  lineWidth,
  radius = 10,
  centerX = null,
  centerY = null
) {
  var context = canvas.getContext("2d");
  centerX = centerX || canvas.width / 2;
  centerY = centerY || canvas.height / 2;
  context.lineWidth = lineWidth;
  context.strokeStyle = color;
  // context.shadowColor = color;
  context.globalAlpha = 1;
  context.beginPath();
  context.arc(centerX, centerY, radius, 0, Math.PI * 2);
  context.stroke();
}

// 绘制X（可变大小和位置）
export function xCanvas(
  canvas,
  color,
  lineWidth,
  size = 15,
  offsetX = 0,
  offsetY = 0
) {
  var context = canvas.getContext("2d");
  context.lineWidth = lineWidth;
  context.globalAlpha = 1;
  context.strokeStyle = color;
  // context.shadowColor = color;
  context.beginPath();
  context.moveTo(offsetX, offsetY);
  context.lineTo(offsetX + size, offsetY + size);
  context.stroke();
  context.beginPath();
  context.moveTo(offsetX, offsetY + size);
  context.lineTo(offsetX + size, offsetY);
  context.stroke();
}

// 绘制正三角形（可变大小和位置）
export function triangleCanvas(
  canvas,
  color,
  lineWidth,
  size = 15,
  offsetX = 0,
  offsetY = 0
) {
  var context = canvas.getContext("2d");
  context.globalAlpha = 1; //透明度
  context.beginPath();
  context.moveTo(offsetX + size / 2, offsetY);
  context.lineTo(offsetX, offsetY + size);
  context.lineTo(offsetX + size, offsetY + size);
  context.closePath();
  context.lineWidth = lineWidth;
  context.strokeStyle = color;
  context.stroke();
}

// 绘制空心正方形（可变大小和位置）
export function squareCanvas(
  canvas,
  color,
  lineWidth,
  size = 15,
  offsetX = 0,
  offsetY = 0
) {
  var context = canvas.getContext("2d");
  context.lineWidth = lineWidth;
  context.globalAlpha = 1;
  context.strokeStyle = color;
  context.strokeRect(0, 0, size, size);
}

// 绘制直角（可变大小和位置）
export function rightAngleCanvas(
  canvas,
  color,
  lineWidth,
  size = 15,
  offsetX = 0,
  offsetY = 0
) {
  var context = canvas.getContext("2d");
  context.globalAlpha = 1;
  context.lineWidth = lineWidth;
  context.strokeStyle = color;
  context.beginPath();

  // 绘制 "L" 形
  context.moveTo(offsetX + size, offsetY); // 从 "L" 形水平边的末端开始
  context.lineTo(offsetX, offsetY); // 水平线到 "L" 形拐点
  context.lineTo(offsetX, offsetY + size); // 从拐点向下画竖线

  context.stroke();
}

// 绘制圆
export function circleCanvas(
  canvas,
  color,
  lineWidth,
  radius = 10,
  centerX = null,
  centerY = null
) {
  var context = canvas.getContext("2d");
  context.lineWidth = lineWidth;
  context.strokeStyle = color;
  context.beginPath();
  context.arc(centerX, centerY, radius, 0, Math.PI * 2);
  context.stroke();
}

//绘制圆加圆上一条线
export function circleLineCanvas(
  canvas,
  color,
  lineWidth,
  radius = 10,
  centerX = null,
  centerY = null
) {
  var context = canvas.getContext("2d");
  context.lineWidth = lineWidth;
  context.strokeStyle = color;
  context.beginPath();
  context.arc(centerX, centerY, radius, 0, Math.PI * 2);
  context.stroke();

  context.beginPath();
  context.moveTo(centerX, centerY);
  context.lineTo(centerX + size, centerY + size);
  context.stroke();
}
